import React from 'react';
import { withRouter } from 'react-router-dom';
import { reduxForm, Field, FieldArray } from 'redux-form';
import { Grid, Divider, Typography, Tooltip } from './../../../../../themes/default';
import { Btn } from './../../../../../components/includes/ui';
import { RemoveCircleIcon, PlaylistAddIcon } from './../../../../../themes/icons';
import { InputTextField, SelectField, OptionField } from './../../../../../components/includes/ui/input';
import { HeadlineThird } from './../../../../../components/includes/headline';
import { Buttons, Boxed } from './../../../../../components/includes/container';
import VALIDATION from './../../../../../config/validation';

const validate = values => {

  const errors = {}

  if (!values.text) {
    errors.text = VALIDATION.required;
  }else if(values.text.length > 1024){
    errors.text = 'El máximo de caracteres es 1024.';
  }

  if (values.caption) {
    if(values.caption.length > 1024){
      errors.caption = 'El máximo de caracteres es 1024.';
    }
  }

  if (values.status === '-1') {
    errors.status = VALIDATION.required;
  }

  if (!values.position) {
    errors.position = VALIDATION.required;
  }else if(Number(values.position) <= 0){
    errors.position = 'La posición debe ser mayor a 0.';
  }

  if (!values.options || !values.options.length) {
    errors.options = { _error: VALIDATION.required }
  }else{
    const optionsArrayErrors = [];
    values.options.forEach((option, optionIndex) => {

      const optionErrors = {};

      if (!option || !option.value) {
        optionErrors.value = VALIDATION.required;
        optionsArrayErrors[optionIndex] = optionErrors;
      }else if(option.value.length > 1024){
        optionErrors.value = 'El máximo de caracteres es 1024.';
        optionsArrayErrors[optionIndex] = optionErrors;
      }

      if (!option || !option.position) {
        optionErrors.position = VALIDATION.required;
        optionsArrayErrors[optionIndex] = optionErrors;
      }

    });

    if (optionsArrayErrors.length) {
      errors.options = optionsArrayErrors;
    }

  }

  console.log(values);

  if(values.start){

  }

  if(values.end){

  }

  return errors;

};

const renderItemsForOptions = ({ fields, meta: { error, submitFailed } }) => (
  <Boxed>

    <HeadlineThird title="Opciones" actions={
      <Btn color="success" onClick={() => fields.push({})}>
        <Tooltip title="Agregar">
          <PlaylistAddIcon fontSize="small"/>
        </Tooltip>
      </Btn>
    }/>

    <div>

      { fields.length > 0 ? (

        fields.map((entity, index) => (
          <Grid container spacing={8} key={ index }>

            <Grid item lg={8} md={8} sm={8} xs={12}>
              <Field
                  name={`${entity}.value`}
                  component={ InputTextField }
                  label="Texto"
                  type="text"
                  required
              />
            </Grid>

            <Grid item lg={2} md={2} sm={2} xs={12}>
              <Field
                  name={`${entity}.position`}
                  component={ InputTextField }
                  label="Posición"
                  type="number"
                  min="1"
                  required
              />
            </Grid>

            <Grid item lg={2} md={2} sm={2} xs={12}>
              <Buttons align="right">
                <Btn color="danger" onClick={() => fields.remove(index)}>
                  <Tooltip title="Eliminar">
                    <RemoveCircleIcon fontSize="small"/>
                  </Tooltip>
                </Btn>
              </Buttons>
            </Grid>

            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Divider/>
            </Grid>

          </Grid>

        ))

      ) : (

        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Typography align="center">
            Debes agregar al menos una opción de respuesta.
          </Typography>
        </Grid>

      )}

    </div>

  </Boxed>
);

class BuilderSelectionOptions extends React.Component {

  componentDidMount(){

  }

  /*
  ** @Submit
  ** @Description: Submit filter form
  */

  handleSubmitForm = (values) => {
    this.props.onSubmit(values);
  }

  /*
  ** @Event
  ** @Description: Cancel
  */

  handleCancel = () => {
    this.props.onCancel();
  }

  render() {

    const { handleSubmit, invalid, selected } = this.props;

    return(

      <form noValidate autoComplete="off" onSubmit={ handleSubmit(this.handleSubmitForm) }>
        <Grid container spacing={24}>

          <Grid item xs={12}>
            <Boxed>
              <Typography variant="h6">
                { selected.title }
              </Typography>
              <Typography>
                { selected.subheader }
              </Typography>
            </Boxed>
          </Grid>

          <Grid item xs={12}>
            <Field
                name="text"
                component={ InputTextField }
                label="Pregunta"
                type="text"
                required
            />
          </Grid>

          <Grid item xs={12}>
            <Field
                name="caption"
                component={ InputTextField }
                label="Aclaración"
                type="text"
            />
          </Grid>

          <Grid item xs={4}>
            <Field
                name="status"
                component={ SelectField }
                label="Requerida"
                required
            >
                  <OptionField key="true" value="true">Si</OptionField>
                  <OptionField key="false" value="false">No</OptionField>
            </Field>
          </Grid>

          <Grid item xs={4}>
            <Field
                name="position"
                component={ InputTextField }
                label="Posición"
                type="number"
                required
            />
          </Grid>

          { selected.type === 'valuation' && (
            <React.Fragment>
              <Grid item xs={4}>
                <Field
                    name="range"
                    component={ SelectField }
                    label="Rango"
                    required
                >
                      <OptionField value="1-5">1 a 5</OptionField>
                      <OptionField value="1-10">1 a 10</OptionField>
                      <OptionField value="0-10">0 a 10</OptionField>
                </Field>
              </Grid>
            </React.Fragment>
          )}

          <Grid item lg={12} md={12} sm={12}>
            <FieldArray name="options" component={ renderItemsForOptions }/>
          </Grid>

          <Grid item xs={12}>
            <Divider/>
          </Grid>

          <Grid item xs={12}>
            <Buttons align="right">
              <Btn aria-label="Volver" icon="back" color="secondary" onClick={ this.handleCancel }>
                Volver
              </Btn>
              <Btn aria-label="Guardar" icon="save" color="success" type="submit" disabled={ invalid }>
                Guardar
              </Btn>
            </Buttons>
          </Grid>

        </Grid>
      </form>

    )
  }

}


BuilderSelectionOptions = reduxForm({
  form: 'BuilderSelectionOptions',
  validate,
  initialValues: {
    status: 'true',
    range: '1-5'
  },
  enableReinitialize: true
})(BuilderSelectionOptions);

export default withRouter(BuilderSelectionOptions);
